<!-- eslint-disable vue/multi-word-component-names -->
<script>
import Vue from 'vue';

import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LControl, LPolyline, LPopup } from 'vue2-leaflet';
import AppTitleHeader from '../../../components/app/TitleHeader.vue';
import EditDialogInformationComponent from '../../../components/115/EditDialogInformationComponent.vue';
// ---------------
import SharedMap from '@/Mixins/map';
import SharedMixin from '@/Mixins/Shared';
import MissionAddressLogMixin from '../../../Mixins/Mission/MissionAddressLogMixin';
import PhoneOnlineLocationMixin from '../../../Mixins/BaseInformation/PhoneOnlineLocationMixin';
import MissionPhonesMixin from '../../../Mixins/Mission/MissionPhonesMixin';
// ---------------
import 'leaflet/dist/leaflet.css';
export default {
  inject: ['load'],
  components: {
    AppTitleHeader,
    EditDialogInformationComponent,
    LMap,
    LTileLayer,
    LMarker,
    LControl,
    LPolyline,
    LPopup,
  },
  mixins: [
    SharedMixin,
    MissionAddressLogMixin,
    PhoneOnlineLocationMixin,
    MissionPhonesMixin,
    SharedMap,
  ],
  props: {
    phoneId: {
      type: Number,
      default: 0,
    },
    missionId: {
      type: Number,
      default: 0,
    },
    missionPhoneId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      addressDataTableHeader: [
        { text: 'آدرس', value: 'address', align: 'center', sortable: false },
        {
          text: 'تاریخ',
          value: 'jalaliDate',
          align: 'center',
          sortable: false,
        },
        { text: 'کاربر', value: 'fullName', align: 'center', sortable: false },
      ],
      mapSingleMovingIconInterval: null,
      // map
      movingIconForPhoneWithMission: require('@/assets/images/phoneWithMission.svg'),
      movingIconForPhoneWithOutMission: require('@/assets/images/phoneWithOutMission.svg'),
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      polyline: {
        latlngs: [],
        color: '#49454F',
      },
    };
  },
  mounted() {
    this.setMapBaseSystemSetting();
    // this.if(this.missionId);
    this.getAllMissionAddressLogFunction(this.missionId);
    this.setIntervalOnGettingPhoneOnlineLocation(this.phoneId);
  },
  beforeDestroy() {
    this.clearIntervalOnGettingPhoneOnlineLocation();
  },
  methods: {
    flyToMarker() {
      const map = this.$refs.modalmap?.mapObject;
      if (!map) return;

      if (this.phoneOnlineLocation) {
        const lat = this.phoneOnlineLocation.latitude;
        const lng = this.phoneOnlineLocation.longitude;

        map.flyTo([lat, lng], 15, {
          duration: 1.5,
        });
      }
    },
    setIntervalOnGettingPhoneOnlineLocation: function (phoneId) {
      if (phoneId) {
        this.getPhoneOnlineLocationFunction(phoneId);
        this.mapSingleMovingIconInterval = setInterval(() => {
          this.getPhoneOnlineLocationFunction(phoneId);
        }, 8000);
      }
    },
    clearIntervalOnGettingPhoneOnlineLocation: function () {
      clearInterval(this.mapSingleMovingIconInterval);
    },
    getMovingIcon(data) {
      if (data.isPhoneLocation == true) {
        //is phone
        if (data.hasMission == true) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForPhoneWithMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        } else if (data.hasMission == false) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForPhoneWithOutMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        }
      } else if (data.isPhoneLocation == false) {
        //is gps
        if (data.hasMission == true) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForGPSWithMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        } else if (data.hasMission == false) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForGPSWithOutMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        }
      }
    },
    loadPath: function (data) {
      this.polyline.latlngs = [];
      if (data.length) {
        for (let i = 0; i < data.length; i++) {
          let temp = [];
          temp.push(data[i].latitude);
          temp.push(data[i].longitude);
          this.polyline.latlngs.push(temp);
        }
      }
    },
    showLine: function () {
      if (this.missionPhoneId) {
        this.getMissionPhoneLocationsFunction(this.missionPhoneId);
      }
    },
  },
  computed: {
    transformedMissionsAddressesLog: function () {
      return [...this.allMissionAddressesLog]?.map(({ user, creationDate, ...rest }) => {
        const { firstName, lastName, userName } = user;
        const fullName = firstName && lastName ? `${firstName} ${lastName}` : userName;
        const jalaliDate = Vue.moment(creationDate || '').format('jYYYY/jMM/jDD-HH:mm:ss');
        return {
          fullName,
          jalaliDate,
          ...rest,
        };
      });
    },
  },
  watch: {
    phoneOnlineLocation: {
      handler(newVal) {
        if (newVal && newVal.latitude && newVal.longitude) {
          this.$nextTick(() => {
            this.flyToMarker();
          });
        }
      },
      immediate: true,
    },
  },
};
</script>
<template>
  <v-row no-gutters class="pa-4">
    <v-col cols="12">
      <app-title-header title="موقعیت آمبولانس" class="mb-4" />

      <div id="map" class="map-container">
        <l-map v-if="isMapReadyToShow" class="map" ref="modalmap" :zoom="zoom" :center="center" :options="mapOptions">
          <l-tile-layer :url="mapTileUrl" :attribution="attribution"></l-tile-layer>
          <l-polyline :lat-lngs="polyline.latlngs" :color="polyline.color"></l-polyline>
          <l-control position="bottomleft">
            <v-btn small rounded dark color="darkColor" class="no-letter-space" @click="showLine()">
              مشاهده مسیر
            </v-btn>
          </l-control>
          <!-- <v-geosearch :options="geosearchOptions"></v-geosearch> -->
          <!-- Marker -->
          <l-marker ref="marker" v-if="phoneOnlineLocation"
            :lat-lng="[phoneOnlineLocation.latitude, phoneOnlineLocation.longitude]"
            :icon="getMovingIcon(phoneOnlineLocation)">
            <l-popup ref="popup">{{ phoneOnlineLocation?.phone?.code }}</l-popup>
          </l-marker>
        </l-map>
      </div>
    </v-col>
    <v-col cols="12" class="mt-4">
      <app-title-header title="سابقه موقعیت" class="mb-4" />
      <section class="">
        <edit-dialog-information-component :tableHeader="addressDataTableHeader"
          :tableItems="transformedMissionsAddressesLog" height="230px" />
      </section>
    </v-col>
  </v-row>
</template>
<style lang="scss" scoped>
.map-container {
  height: 230px;

  .map {
    height: 100%;
    width: 100%;
  }
}
</style>
